import React from 'react'
import styles from './styles.css'
import {Link} from 'react-router'
import User from './User'
import Container from 'orionsoft-parts/lib/components/Container'
import PropTypes from 'prop-types'
import withOrganization from 'App/Decorators/withOrganization'
import contextUrl from '../../../Root/contextUrl'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'

@withMutation(gql`
  mutation organizationImages($contextUrl: String!) {
    organizationImages(contextUrl: $contextUrl) 
  }
`)

@withOrganization
export default class Navbar extends React.Component {
  static propTypes = {
    scrollY: PropTypes.number,
    organizationImages: PropTypes.func,
    organization: PropTypes.object
  }
  
  state = {
    banner: '/logotufirma.svg',
    tengoLogo: false,
    fetched: false
  }

  async fetchOrgImages(){
    this.setState({fetched:true})
    let resultado = await this.props.organizationImages({contextUrl: contextUrl})
    if(resultado && resultado.organizationImages){
      //console.log("Resultado fetchOrgImages:", resultado.organizationImages)
      this.setState({banner: resultado.organizationImages.banner, tengoLogo: true})
    } else {
      this.setState({tengoLogo: true})
    }
  }

  renderBannerImage(){
    if( this.state.tengoLogo )
      return (
        <img src={this.state.banner} alt="Logo" />
      )
  }
  
  renderTufirmaLogo() {
    return (
      <div className={styles.container}>
        <Container>
          <div className={styles.content}>
            <div className={styles.logo}>
              <Link to="/">
                {this.renderBannerImage()}
              </Link>
            </div>
            <div className={styles.middle} />
            <div className={styles.user}>
              <User />
            </div>
          </div>
        </Container>
      </div>
    )
  }

  renderOrganizationLogo() {
    return (
      <div className={styles.container}>
        <Container>
          <div className={styles.content}>
            <div className={styles.logo}>
              <Link to="/">
                <img src={this.props.organization.logo.url} alt="OrganizationLogo" />
              </Link>
            </div>
            <div className={styles.middle} />
            <div className={styles.user}>
              <User />
            </div>
          </div>
        </Container>
      </div>
    )
  }

  render() {
    if(!this.state.fetched){
      this.fetchOrgImages()
    }
    if (this.props.organization && this.props.organization.logo) {
      return this.renderOrganizationLogo()
    } else {
      return this.renderTufirmaLogo()
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Layout/Navbar/index.js